/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface AdminFhirIdParentOrganizationSpecialitiesGet$Params {
  fhirId: string;
}

export function adminFhirIdParentOrganizationSpecialitiesGet(http: HttpClient, rootUrl: string, params: AdminFhirIdParentOrganizationSpecialitiesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdParentOrganizationSpecialitiesGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

adminFhirIdParentOrganizationSpecialitiesGet.PATH = '/Admin/{fhirId}/ParentOrganizationSpecialities';
